export default {"src":"/_next/static/media/white_circle_bg.b865470f.svg","height":332,"width":302,"blurWidth":0,"blurHeight":0};